import { render } from "./LateralMenu.vue?vue&type=template&id=700ddb42&scoped=true"
import script from "./LateralMenu.vue?vue&type=script&lang=js"
export * from "./LateralMenu.vue?vue&type=script&lang=js"

import "./LateralMenu.vue?vue&type=style&index=0&id=700ddb42&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700ddb42"]])

export default __exports__